import {
    Box,
    Button,
    Container,
    Flex,
    Heading,
    Icon,
    Stack,
    Text,
    useColorModeValue,
} from '@chakra-ui/react';
import { ReactElement } from 'react';
import {
    FcAbout,
    FcAssistant,
    FcCollaboration,
    FcDonate,
    FcManager,
} from 'react-icons/fc';
import {AiFillDashboard, AiOutlineFieldTime, AiOutlineTranslation} from 'react-icons/ai'
import { BsTextareaT } from 'react-icons/bs'
import {MdAppShortcut, MdOutlineCategory} from 'react-icons/md'
import { HiCursorClick } from 'react-icons/hi'
import { GoBrowser } from 'react-icons/go'
interface CardProps {
    heading: string;
    description: string;
    icon: ReactElement;
    href: string;
}

const Card = ({ heading, description, icon, href }: CardProps) => {
    return (
        <Box
            maxW={{ base: 'full', md: '275px' }}
            w={'full'}
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            p={5}>
            <Stack align={'start'} spacing={2}>
                <Flex
                    w={16}
                    h={16}
                    align={'center'}
                    justify={'center'}
                    color={'white'}
                    rounded={'full'}
                    bg={useColorModeValue('gray.100', 'gray.700')}>
                    {icon}
                </Flex>
                <Box mt={2}>
                    <Heading size="md">{heading}</Heading>
                    <Text mt={1} fontSize={'sm'}>
                        {description}
                    </Text>
                </Box>
                {/* <Button variant={'link'} colorScheme={'blue'} size={'sm'}>
                    Learn more
                </Button> */}
            </Stack>
        </Box>
    );
};

export default function Features() {
    return (
        <Box my={12} p={4}>
            <Stack spacing={4} as={Container} maxW={'3xl'} textAlign={'center'}>
                <Heading color={'green.400'} fontSize={{ base: '2xl', sm: '4xl' }} fontWeight={'bold'}>
                    Why Headsup?
                </Heading>
                {/* <Text color={'gray.600'} fontSize={{ base: 'sm', sm: 'lg' }}>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis
                    obcaecati ut cupiditate pariatur, dignissimos, placeat amet officiis.
                </Text> */}
            </Stack>

            <Container my={8} maxW={'5xl'} mt={12}>
                <Flex flexWrap="wrap" gridGap={6} justify="center">
                    <Card
                        heading={'Right Click Menu'}
                        icon={<Icon as={HiCursorClick} color={"green.400"} w={10} h={10} />}
                        description={
                            'Context Menu based bookmarking, Right click and put the bookmark in your category no need to move all the way to top :)'
                        }
                        href={'#'}
                    />
                    <Card
                        heading={'Selection Text'}
                        icon={<Icon as={BsTextareaT} color={"green.400"} w={10} h={10} />}
                        description={
                            'Select a certain word or phrase you feel would trigger you to check the bookmark'
                        }
                        href={'#'}
                    />
                     <Card
                        heading={'Multilingual'}
                        icon={<Icon as={AiOutlineTranslation} color={"green.400"} w={10} h={10} />}
                        description={
                            'Supporting multiple languages, across multiple regions'
                        }
                        href={'#'}
                    />
                    
                    <Card
                        heading={'New Tab'}
                        icon={<Icon as={GoBrowser} color={"green.400"} w={10} h={10} />}
                        description={
                            'Everytime, you open the Chrome, you will see All bookmarks you need'
                        }
                        href={'#'}
                    />
                     <Card
                        heading={'Customization at Ease'}
                        icon={<Icon as={MdOutlineCategory} color={"green.400"} w={10} h={10} />}
                        description={
                            'From dark mode to all backgrounds for your panels'
                        }
                        href={'#'}
                    />
                     <Card
                        heading={'Daily Links Highlight'}
                        icon={<Icon as={MdAppShortcut} color={"green.400"} w={10} h={10} />}
                        description={
                            'Important daily usage links are filtered and on a click away'
                        }
                        href={'#'}
                    />
                    <Card
                        heading={'Category based'}
                        icon={<Icon as={MdOutlineCategory} color={"green.400"} w={10} h={10} />}
                        description={
                            'Categorize your bookmark based on your preference, add custom ones'
                        }
                        href={'#'}
                    />
                    <Card
                        heading={'Time to Remind'}
                        icon={<Icon as={AiOutlineFieldTime} color={"green.400"} w={10} h={10} />}
                        description={
                            'A Weekly Email with all the links that are not noticed yet by you'
                        }
                        href={'#'}
                    />
                    <Card
                        heading={'Dashboard for you'}
                        icon={<Icon as={AiFillDashboard} color={"green.400"} w={10} h={10} />}
                        description={
                            'From World Clock to weather and all data at your feed'
                        }
                        href={'#'}
                    />
                </Flex>
            </Container>
        </Box>
    );
}